import { AnimationBaseController, IAnimationControllerConfiguration, Inject } from "@denishussar/html5-game-engine";
import { AnimationContents } from "../../../AnimationContents";
import { GameModel, GamePlayerTypeEnum } from "../../Models/GameModel";

export interface IAnimateCarOptions {
    type: GamePlayerTypeEnum;

}

export class AnimateCarController extends AnimationBaseController {
    $model: GameModel;

    constructor(
        @Inject private options: IAnimateCarOptions,
    ) {
        super("AnimateCarController");
    }


    getConfiguration(): IAnimationControllerConfiguration {

        let car = ""
        switch (this.options.type) {
            case GamePlayerTypeEnum.delorean:
                car = "car_delorean";
                break;
            case GamePlayerTypeEnum.ferrari:
                car = "car_ferra";
                break;
            case GamePlayerTypeEnum.lamborgini:
                car = "car_lamba";
                break;
            default:
                car = "car_vaz";
        }

        return {
            animationContent: AnimationContents.GAME_SCREEN_JSON,
            libraryName: car,
        }
    }

    onInitialize() {

    }

    public setDirection(dir: number): void {
        // this.spineCar.setAnimation(spineAnimations.idle, false);
        switch (dir) {
            case -1:
                this.gotoAndStop("left");
                break;
            case 0:
                this.gotoAndStop("mid");
                break;
            case 1:
                this.gotoAndStop("right");
                break;
        }
    }
}